var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"protein-viewer-container"}},[_c('div',{ref:"proteinViewer",staticClass:"protein-viewer"}),(_vm.loadingError)?_c('div',{staticClass:"error-container"},[_c('p',[_vm._v("Failed to load the protein structure.")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }